<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="crt2"><a id="page4"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the authors’ imaginations or are used fictitiously.</p>
<p class="crt1"><span class="small">THE UNINCORPORATED WAR</span></p>
<p class="crt1">Copyright © 2010 by Dani Kollin and Eytan Kollin</p>
<p class="crt1">All rights reserved.</p>
<p class="crt1">A Tor Book</p>
<p class="crt">Published by Tom Doherty Associates, LLC</p>
<p class="crt">175 Fifth Avenue</p>
<p class="crt">New York, NY 10010</p>
<p class="crt1"><a href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="crt1">Tor® is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="crt1">ISBN 978-0-7653-1900-5</p>
<p class="crt1">First Edition: May 2010</p>
<p class="crt1">Printed in the United States of America</p>
<p class="crt1">0 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Unincorporated_copy.vue?b1a83b6c